import { getTicketTypePending, getTicketTypeSuccess, getTicketTypeFail, 
    deleteTicketTypePending, deleteTicketTypeSuccess, deleteTicketTypeFail,
    getSTicketTypePending, getSTicketTypeSuccess, getSTicketTypeFail, 
    createTicketTypePending, createTicketTypeSuccess, createTicketTypeFail, 
    modifyTicketTypePending, modifyTicketTypeSuccess, modifyTicketTypeFail } from "./TicketTypeSlice";
import { fetchAllTicketType, ticketTypeDelete, ticketTypeCreation, ticketTypeModify, fetchSingleTicketType } from "../../../api/userApi";
import Swal from "sweetalert2";

export const getAllTicketType = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getTicketTypePending());
        const result = await fetchAllTicketType();
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

        //console.log('allCityData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const ticketTypedetails = JSON.parse(JSON.stringify(myObj.tickettypes));
        const ticketTypedetails1 = JSON.parse(JSON.stringify(ticketTypedetails));
        
        if (ticketTypedetails) {
        
            return dispatch(getTicketTypeSuccess(ticketTypedetails));
        }
        dispatch(getTicketTypeFail("Ticket Type is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getTicketTypeFail(err.msg));

    }
}

export const ticketTypeDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteTicketTypePending());
        const result = await ticketTypeDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteTicketTypeSuccess("Ticket Type deleted"))
        : dispatch(deleteTicketTypeFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteTicketTypeFail(err.msg));
    }
    
}

export const newTicketTypeCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createTicketTypePending());
        const result = await ticketTypeCreation(frmDt);
        //console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createTicketTypeSuccess(result.message))
            : dispatch(createTicketTypeFail(result.message));

          

    } catch (error) {
         //console.log("catch block");
         console.log(error);
         if(error.response.status===401){}
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error');
       
      
          dispatch(createTicketTypeFail(err.msg));
       
    }

}

export const getSingleTicketType = (id) => async (dispatch) => {
    
 
 
    try {
     //call the api
    dispatch(getSTicketTypePending());
    const result = await fetchSingleTicketType(id);

 
 //console.log('check user profile out if');
    if(result.tickettypes[0] && result.tickettypes[0].id){
    //console.log('check user profile');
        return dispatch(getSTicketTypeSuccess(result.tickettypes[0]));
    }
    dispatch(getSTicketTypeFail("Ticket Type is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
    console.log(err.msg);
    dispatch(getSTicketTypeFail(err.msg));
 
 }
    
 
 }




export const ticketTypeModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyTicketTypePending());
        const result = await ticketTypeModify(frmDt);
        if (result.status === "success") {
            dispatch(modifyTicketTypeSuccess(result.message));
            Swal.fire('Ticket type updated successfully', '', 'success');
        } else {
            dispatch(modifyTicketTypeFail(result.message));
        }
    } catch (error) {
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error');
        dispatch(modifyTicketTypeFail(err.msg));
    }
    

}
